import type { CityLocation, EventListViewModel } from "src/http/types";
import { type Location, LocationSourceType } from "src/types/shared/cookies";
import { ENTITY_TYPES } from "src/website-apps/shared/components/grid/favorites-fs/constants";
import { getPerformerSurfaceEventItems } from "src/website-apps/shared/utils/performerGridSurface";

/**
 * Builds the page-level location from the backend's team-home override. The label is the city only
 * so the filter chip matches the concise format of user-selected and SEO locations.
 */
export const buildLocationOverride = (city: CityLocation | null | undefined): Location | undefined => {
  if (!city) {
    return undefined;
  }

  return {
    ct: city.countryName,
    n: city.cityName ?? "?",
    lt: city.latitude ?? 0,
    lg: city.longitude ?? 0,
    src: LocationSourceType.QUERY_PARAM,
  };
};

/**
 * @param model - Header content to display above the banner
 */
export const resolveInitialFavoritesStateFromPerformerPageModel = (model: EventListViewModel) => {
  const performers = [model.categorySummary];
  const events = getPerformerSurfaceEventItems(model.performerGridSurface);
  const performerFavorites = performers.reduce((acc: Record<number, Record<number, boolean | undefined>>, curr) => {
    const categoryGroup = acc[ENTITY_TYPES.CATEGORY] ?? {};
    if (curr.categoryId !== undefined) {
      categoryGroup[curr.categoryId] = curr.isFavorite;
    }
    return { ...acc, [ENTITY_TYPES.CATEGORY]: categoryGroup };
  }, {});
  const eventFavorites = events.reduce((acc: Record<number, Record<number, boolean | undefined>>, curr) => {
    const eventGroup = acc[ENTITY_TYPES.EVENT] ?? {};
    eventGroup[curr.eventId] = curr.isFavorite;
    return { ...acc, [ENTITY_TYPES.EVENT]: eventGroup };
  }, {});
  return {
    ...performerFavorites,
    ...eventFavorites,
  };
};
